import {Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import {put, takeLatest} from 'redux-saga/effects'
import {UserModel} from '../models/UserModel'
import {getUserByToken} from './AuthCRUD'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  Login: '[Login] Action',
  Logout: '[Logout] Action',
  Register: '[Register] Action',
  UserRequested: '[Request User] Action',
  UserLoaded: '[Load User] Auth API',
  SetUser: '[Set User] Action',
}

const initialAuthState: IAuthState = {
  user: undefined,
  userId: undefined,
  apiToken: undefined,
}

export interface IAuthState {
  user?: UserModel
  userId?: string,
  apiToken?: string
}

export const reducer = persistReducer(
  {storage, key: 'auth', whitelist: ['user', 'userId', 'apiToken']},
  (state: IAuthState = initialAuthState, action: ActionWithPayload<IAuthState>) => {
    console.log(action.type)
    console.log(action.payload)
    switch (action.type) {
      case actionTypes.Login: {
        const userId = action.payload?.userId
        const apiToken = action.payload?.apiToken
        return {userId, apiToken, user: undefined}
      }

      case actionTypes.Register: {
        const apiToken = action.payload?.apiToken
        return {apiToken, user: undefined}
      }

      case actionTypes.Logout: {
        return initialAuthState
      }

      case actionTypes.UserRequested: {
        return {...state, user: undefined}
      }

      case actionTypes.UserLoaded: {
        const user = action.payload?.user
        return {...state, user}
      }

      case actionTypes.SetUser: {
        const user = action.payload?.user
        return {...state, user}
      }

      default:
        return state
    }
  },
)

export const actions = {
  login: (result: any) => ({type: actionTypes.Login, payload: {userId: result.id, apiToken: result.api_token}}),
  register: (accessToken: string) => ({
    type: actionTypes.Register,
    payload: {accessToken},
  }),
  logout: () => ({type: actionTypes.Logout}),
  requestUser: () => ({
    type: actionTypes.UserRequested,
  }),
  fulfillUser: (user: UserModel) => ({type: actionTypes.UserLoaded, payload: {user}}),
  setUser: (user: UserModel) => ({type: actionTypes.SetUser, payload: {user}}),
}

export function* saga() {
  yield takeLatest(actionTypes.Login, function* loginSaga() {
    yield put(actions.requestUser())
  })

  yield takeLatest(actionTypes.Register, function* registerSaga() {
    yield put(actions.requestUser())
  })

  yield takeLatest(actionTypes.UserRequested, function* userRequested() {
    const {data} = yield getUserByToken()
    if (data.error === '' && data.result.admin > 0) {
      yield put(actions.fulfillUser(data.result))
    }
  })
}
